<template>
  <div
    @mouseenter="handleHover(true)"
    @mouseleave="handleHover(false)"
    :class="{hovered: indicator.indicatorHovered}"  
    class="indicator-label">
    {{indicator.name}}
    </div>
</template>

<script>
import handleHover from '../../helpers/hoverHelpers';

export default {
  name: 'legend-indicator',
  props: ['indicator'],
  methods: {
    handleHover,
  },
};
</script>

<style lang="less">
  .indicators-block {
    box-sizing: border-box;
    padding-bottom: 7px;
    padding-left: 20px;
  }
  .indicator-label {
    height: 20px;
    margin: 3px 0;
    white-space: nowrap;
    z-index: -1;

    &.hovered {
      overflow: visible;
      text-overflow: visible;
      font-weight: bold;
      position: relative;
      z-index: 1000;
    }

    @media(max-width: 1200px) {
      box-sizing: border-box;
      width: 260px;
      white-space: normal;
      height: 40px;
      padding-top: 5px;
    }

    @media(max-width: 800px) {
      width: 210px;
    }
  }
</style>



// WEBPACK FOOTER //
// LegendIndicator.vue?2a3c7708